import React from 'react';
import styles from '../assets/styles/Footer.module.css';
import ContactUsSection from './ContactUsSection.jsx';

const Footer = () => {
  return (
    <div>
      <div id='contact'><ContactUsSection /></div>
      <footer className={styles.footer}>
        Starnet Legal | 2025
      </footer>
    </div>
  );
};

export default Footer;